let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3c33e")).then(() => parcelRequire('bdOyr'));